export interface AtomEvent {
  id: string;
  value: string;
}
